const CONTROL_STATUSES = ["Verified and Operational", "Implemented — Verification Pending", "Partially Implemented", "Not Implemented",
  "Not Applicable", "Owner Approval Required", "Legal Review Required", "Unknown / Insufficient Evidence"];

export const SUBPROCESSOR_FIELDS = [
  { key: "name", label: "Supplier", table: true },
  { key: "service", label: "Service", table: true },
  { key: "purpose", label: "Purpose", type: "textarea" },
  { key: "data_categories", label: "Data categories", table: true },
  { key: "region", label: "Processing region", table: true },
  { key: "transfer_mechanism", label: "Transfer mechanism" },
  { key: "role", label: "Role", type: "select", options: ["Subprocessor", "Sub-subprocessor (via Emergent)", "Independent controller", "Independent controller for payment processing (when enabled)", "Third party"] },
  { key: "contract_status", label: "Contract / DPA status", table: true },
  { key: "dd_status", label: "Due diligence", type: "select", options: ["pending", "complete", "not_required"], table: true },
  { key: "dd_notes", label: "Due diligence notes (internal)", type: "textarea" },
  { key: "next_review", label: "Next review", type: "date", table: true },
];

export const INCIDENT_FIELDS = [
  { key: "title", label: "Title", table: true },
  { key: "kind", label: "Type", type: "select", options: ["security_incident", "personal_data_breach", "vulnerability", "near_miss"], table: true },
  { key: "severity", label: "Severity", type: "select", options: ["critical", "high", "medium", "low"], table: true },
  { key: "status", label: "Status", type: "select", options: ["open", "contained", "eradicated", "recovered", "closed"], default: "open", table: true },
  { key: "discovered_at", label: "Discovered at", type: "datetime", table: true },
  { key: "affected_licensees", label: "Licensees / data affected" },
  { key: "personal_data_involved", label: "Personal data involved?", type: "select", options: ["yes", "no", "unknown"] },
  { key: "controller_notified_at", label: "Controller notified at", type: "datetime", table: true },
  { key: "due_date", label: "Next action due", type: "date", table: true },
  { key: "description", label: "What happened", type: "textarea" },
  { key: "containment", label: "Containment & evidence preserved", type: "textarea" },
  { key: "root_cause", label: "Root cause", type: "textarea" },
  { key: "corrective_actions", label: "Corrective actions (owner, date)", type: "textarea" },
];

export const CONTROL_FIELDS = [
  { key: "area", label: "Area", table: true },
  { key: "title", label: "Requirement / control", table: true },
  { key: "source", label: "Source (law, contract, standard)", table: true },
  { key: "status", label: "Status", type: "select", options: CONTROL_STATUSES, table: true },
  { key: "evidence", label: "Evidence location / test method", type: "textarea", table: true },
  { key: "owner", label: "Owner" },
  { key: "last_review", label: "Last reviewed", type: "date", table: true },
  { key: "gaps", label: "Outstanding gaps / remediation", type: "textarea" },
];
